import { segment } from '../segment'

export const trackSessionStart = async (): Promise<void> => {
  const sessionKey = 'segment_session_started'
  if (sessionStorage.getItem(sessionKey)) return

  segment.identify()
  segment.track('Session Started')

  sessionStorage.setItem(sessionKey, 'true')
}

segment.ready(async () => {
  try {
    await trackSessionStart()
  } catch (error) {
    console.error('Error tracking session start:', error)
  }
})
